import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import AppknoxMappingForm from './AppknoxMappingForm';

function AppknoxCredentialsForm(props, ref){
    const fields = [{
        name: "token",
        label: "Token",
        type: FieldTypes.PASSWORD,
        required: true,
    }]
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={AppknoxMappingForm}
        />
    )
}

export default forwardRef(AppknoxCredentialsForm);